export default {
  areas: {
    hero: {
      eyebrow: 'Zona e shërbimit',
      title: 'Kamera sigurie dhe alarme në të gjithë rajonin Rhein-Main',
      subtitle: 'Nga Frankfurti përmes Offenbach, Hanau dhe Darmstadt deri në Groß-Gerau: SSG Signaltechnik planifikon, instalon dhe mirëmban mbikëqyrjen me video dhe sistemet e alarmit për privatë dhe biznese – personalisht dhe në vend.',
      ctaPrimary: 'Kërkoni një konsultim të parë falas',
      ctaSecondary: 'Zbuloni mbikëqyrjen me video',
    },
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbCurrent: 'Zona e shërbimit',
    intro: {
      eyebrow: 'Ku jemi aktivë për ju',
      title: 'Distanca të shkurtra në të gjithë rajonin',
      p1: 'Kompania jonë e specializuar në teknologjinë e sigurisë e ka selinë në Hainburg – dhe lëviz shpejt në të gjithë rajonin Rhein-Main. Kamerë sigurie, mbikëqyrje me video apo alarm: vijmë te ju, analizojmë pronën dhe montojmë gjithçka pastër e profesionalisht.',
      p2: 'Qoftë shtëpi private, pallat, dyqan, zyrë, magazinë apo punishte – trajtojmë projekte të çdo madhësie në Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau dhe qytetet përreth.',
    },
    city: 'Qytet',
    district: 'Rreth',
    coverage: {
      eyebrow: 'Të rrënjosur lokalisht',
      title: 'Specialisti juaj nga rajoni – për rajonin',
      p1: 'Si kompani lokale e teknologjisë së sigurisë në rajonin Rhein-Main, i njohim kërkesat dhe kushtet në vend. Për kamerën ose alarmin tuaj: distanca të shkurtra, kontakte personale dhe takime të shpejta.',
      p2: 'Lëvizim edhe jashtë rajonit Rhein-Main sipas marrëveshjes. Na kontaktoni – do të kontrollojmë me kënaqësi çfarë është e mundur për projektin tuaj.',
      ctaPrimary: 'Kërkoni tani',
      ctaSecondary: 'Zbuloni sistemet e alarmit',
      caption: 'Montim dhe konfigurim personal në vend – nga Hainburg në të gjithë rajonin Rhein-Main.',
    },
    cta: {
      title: 'Kamerë sigurie apo alarm për pronën tuaj?',
      lead: 'Ju këshillojmë pa detyrim dhe ju tregojmë zgjidhjen që i përshtatet pronës dhe buxhetit tuaj – në të gjithë rajonin Rhein-Main dhe rrethinën.',
      primary: 'Kërkoni një konsultim të parë falas',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
};